export interface InitResponseData {
  keyword: string;
  metadata: {
    [k: string]: string;
  };
  reminderData?: ReminderData;
}

export interface ReminderData {
  bin: string;
  pcn: string;
  memberId: string;
  groupId: string;
  ezWalletResponse: Record<string, string>;
}

export interface EnrollmentResponse {
  enrollment?: {
    bin: string;
    pcn: string;
    groupId: string;
    memberId: string;
    ezWalletResponse: {
      qrPdfUrl: string;
      qrImageUrl: string;
      qrImageBase64Url: string;
      walletPassUrl: string;
      walletPassShortUrl: string;
      copayCardImageUrl: string;
    };
  };
}

export interface Globals {
  initResponse: InitResponseData;
  enrollmentResponse?: EnrollmentResponse;
}

export const GLOBALS: Globals = {
  initResponse: {
    keyword: '',
    metadata: {},
    reminderData: {
      bin: '',
      pcn: '',
      memberId: '',
      groupId: '',
      ezWalletResponse: {},
    },
  },
};
